export const fileTypes = [
    {
        fileTitle: 'File A: Appropriation',
        requestName: 'appropriations',
        progress: '0'
    },
    {
        fileTitle: 'File B: Program Activity & Object Class Data',
        requestName: 'program_activity',
        progress: '0'
    },
    {
        fileTitle: 'File C: Award Financial',
        requestName: 'award_financial',
        progress: '0'
    }
];
export { fileTypes as default };
